module.exports = __webpack_public_path__ + "img/tgm.e1ea7248.png";